module.exports = __webpack_public_path__ + "static/images/409a25807e6d047f040c60ade5ad8a95.webp";